import { stringifyQs } from "@saleor/utils/urls";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const GrabExpresssSection = "/reports/omi/grab-express";

export const GrabExpressListPath = GrabExpresssSection;

export enum GrabExpressListUrlFiltersEnum {
  query = "query",
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo"
}

export enum GrabExpresssListUrlFiltersWithMultipleValues {
  mall = "mall",
  orderStatus = "orderStatus",
  deliveryType = "deliveryType"
}

export type GrabExpressListUrlDialog = "download" | TabActionDialog;
export type GrabExpressListUrlFilters = Filters<GrabExpressListUrlFiltersEnum> &
  FiltersWithMultipleValues<GrabExpresssListUrlFiltersWithMultipleValues>;

export type GrabExpressUrlQueryParams = ActiveTab &
  GrabExpressListUrlFilters &
  BulkAction &
  Dialog<GrabExpressListUrlDialog> &
  Pagination &
  SingleAction;

export const grabExpressListUrl = (params?: GrabExpressUrlQueryParams) =>
  GrabExpressListPath + "?" + stringifyQs(params);

export const GrabExpressPath = GrabExpresssSection;
